export const CUSTOMER_OVERLAY_LAYERS = {
    dropdown: 50,
    actionSheetBackdrop: 60,
    fullscreenEditor: 70,
    utilityModal: 80,
    selectionBackdrop: 89,
    selectionPanel: 90,
} as const
